import { Coordinate2D } from '@/types'
import { BubbleMetadata } from '../../BubblesV2/Metadata'
import { XYVisNode } from '../types'
import { XYBubbleHaloMetadata } from './XYBubbleHaloMetadata'
import { XYBubblePulseMetadata } from './XYBubblePulseMetadata'

export class XYBubbleMetadata extends BubbleMetadata {
  static maximumRadius = 250
  private _xyVisNode: XYVisNode
  private _xyHaloMetadata: XYBubbleHaloMetadata
  private _xyPulseMetadata: XYBubblePulseMetadata
  radiusScale: number = 1
  zIndex: number = 0

  constructor(visNode: XYVisNode, initialPosition: Coordinate2D) {
    super(visNode, initialPosition)

    this._xyHaloMetadata = new XYBubbleHaloMetadata(this)
    this._xyPulseMetadata = new XYBubblePulseMetadata(this)

    this._xyVisNode = visNode
  }

  get key() {
    return this._xyVisNode.key
  }

  get xAxisTickKey() {
    return this._xyVisNode.xAxisTickKey
  }

  get yAxisValue() {
    return this._xyVisNode.yAxisValue
  }

  get haloMetadata(): XYBubbleHaloMetadata {
    return this._xyHaloMetadata
  }

  get pulseMetadata(): XYBubblePulseMetadata {
    return this._xyPulseMetadata
  }

  get sqrtTotal(): number {
    return Math.sqrt(this.absScaledTotal)
  }

  get radius(): number {
    const dataValueRadius = this.sqrtTotal * this.radiusScale

    // The Bubble's minimum size is the configured border width
    const minimumRadius = this.borderWidth

    return Math.max(dataValueRadius, minimumRadius)
  }
}
